import React, { FC } from 'react';
import { MotionBox } from '@olo-web/components/atoms/motion/MotionBox.ui';
import { BoxProps, Icon, IconProps } from '@chakra-ui/react';
import { ChevronDown } from 'react-feather';
import { MotionProps } from 'framer-motion';

type CollapseChevronPropsType = BoxProps & MotionProps;

interface I extends CollapseChevronPropsType {
  isUp?: boolean;
  iconProps?: IconProps;
}

export const CollapseChevron: FC<I> = (props) => {
  const { isUp, iconProps = {}, ...rest } = props;

  return (
    <MotionBox
      animate={{
        transform: `rotate(${isUp ? -180 : 0}deg)`,
      }}
      {...rest}
    >
      <Icon h={7} w={7} as={ChevronDown} {...iconProps} />
    </MotionBox>
  );
};
